export default "__VITE_ASSET__Bcr1QSKZ__$_?nuxt_component=async&nuxt_component_name=IUsdgLogoUsimsaLogoIcon__"